import React from "react";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import { CopyField } from "../../../components/ui";

/**
 * Temporary password shown once, only when it could not be emailed (mail
 * service unavailable): to pass on to the admin in person.
 */
const TemporaryPasswordDialog = ({ admin, password, onClose }) => {
  const { t } = useTranslation();
  return (
    <Modal show={true} onHide={onClose} centered dialogClassName="ui-modal">
      <Modal.Header>
        <Modal.Title>{t("Temporary password")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {t("The email could not be sent. Give this temporary password to")} <strong>{admin?.name || admin?.email}</strong>{" "}
          {t("in person; it will not be shown again.")}
        </p>
        <CopyField id="temporary-password" label={t("Temporary password")} value={password} />
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="ui-btn" onClick={onClose}>
          {t("Done")}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default TemporaryPasswordDialog;
